const OrderCaptcha = {
    data() {
        return {
            captchaID: null,
        };
    },
    mounted() {
        const _this = this;
        window.loadCaptcha(() => {
            if (this.needChallenge) {
                hcaptcha.reset(_this.captchaID);
            } else {
                _this.captchaID = hcaptcha.render(_this.$refs.captcha, {
                    sitekey: process.env.MIX_HCAPTCHA_TOKEN,
                });
            }
        });
    },
    methods: {
        captchaSubmit(event) {
            event.preventDefault();
            let captchaResponse = event.target["h-captcha-response"].value;
            if(location.href.indexOf("&h_captcha_response")>0){
                location.href = location.href.substring(0,location.href.indexOf("&h_captcha_response")) + "&h_captcha_response=" + captchaResponse;
            }else {
                location.href = location.href + "&h_captcha_response=" + captchaResponse;
            }
        },
    },
};

// Global Order object
const ORDERCAPTCHA = {
    vue: null,
    load() {
        if (document.getElementById("order_captcha") !== undefined) {
            this.vue = Vue.createApp(OrderCaptcha).mount("#order_captcha");
            forms.load();
        }
    },
};
window.ORDERCAPTCHA = ORDERCAPTCHA;

window.addEventListener("DOMContentLoaded", () => {
    ORDERCAPTCHA.load();
});

if (document.readyState !== "loading") {
    ORDERCAPTCHA.load();
}
